export const formatName = (person: { firstName: string; lastName: string }) =>
  `${person.lastName} ${person.firstName}`.trim();
